var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'moving-arrow-mini': _vm.isMini, 'moving-arrow': !_vm.isMini },style:(_vm.arrowStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }